import React, { useContext, useState } from "react";
import { Offcanvas } from "react-bootstrap";
// import { Dropdown, DropdownButton, NavDropdown } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { RiCloseFill, RiGridFill } from "react-icons/ri";
import { FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BsFillSunFill, BsFillMoonFill } from "react-icons/bs";
// import { BsFillMoonFill } from "react-icons/bs";
import { contextpass } from "../App";

function NavbarMain() {
  const { pass,social } = useContext(contextpass);
  const [mode, setmode] = pass;
  const [sicon, setsicon] = social;

  let Change = () => {
    setmode((n) => !n);
  };


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setsicon(false);
  };

  console.log(sicon);
  const navto = useNavigate();
  const home = () => {
    navto("/");
    setShow(false);
  };
  const about = () => {
    navto("/about");
    setShow(false);
  };
  const expedu = () => {
    navto("/expedu");
    setShow(false);
  };
  const portfolio = () => {
    navto("/portfolio");
    setShow(false);
  };
  const skills = () => {
    navto("/skills");
    setShow(false);
  };
  const contact = () => {
    navto("/contact");
    setShow(false);
  };
  return (
    <React.Fragment>
      <Navbar className="header" fixed="top" expand="lg">
        <Container fluid>
          <Nav className="me-auto nav-style align-items-center text-white">
            <motion.button
              initial={{ opacity: 0.6 }}
              whileHover={{
                scale: 1.2,
                transition: { duration: 1 },
              }}
              whileTap={{ scale: 0.9 }}
              whileInView={{ opacity: 1 }}
              className="btn text-white align-items-center border-0"
              onClick={() => navto("/")}
            >
              <FaHome className="m-0 p-0 menu-icon" />
            </motion.button>
          </Nav>
          {/* <Nav className="ms-auto nav-style align-items-center">
            
          </Nav> */}
          <Nav className="ms-auto nav-style align-items-center d-inline">
            <div className="d-inline">
              <motion.button
                initial={{ opacity: 0.6 }}
                whileHover={{
                  scale: 1.2,
                  transition: { duration: 1 },
                }}
                whileTap={{ scale: 0.9 }}
                whileInView={{ opacity: 1 }}
                className="btn text-white align-items-center border-0"
                onClick={Change}
              >
                {mode === true ? (
                  <BsFillSunFill className="m-0 p-0 day-night" />
                ) : (
                  <BsFillMoonFill className="m-0 p-0 day-night" />
                )}
              </motion.button>
            </div>
            <div className="d-inline">
              <motion.button
                initial={{ opacity: 0.6 }}
                whileHover={{
                  scale: 1.2,
                  transition: { duration: 1 },
                }}
                whileTap={{ scale: 0.9 }}
                whileInView={{ opacity: 1 }}
                className="btn text-white align-items-center border-0 "
                onClick={handleShow}
              >
                <RiGridFill className="m-0 p-0 menu-icon" />
              </motion.button>
            </div>
          </Nav>
          <Offcanvas
            show={show}
            onHide={handleClose}
            className="w-100 h-100 align-items-center text-center bg-menu"
            placement="bottom"
          >
            
            <Offcanvas.Body className="bodyoffcanvas">
              <ul className="navul p-0" type="none">
                <li>
                 
                  <button onClick={home} className="btn">
                    Home
                  </button>
                </li>
                <li>
                
                  <button onClick={about} className="btn">
                    About
                  </button>
                </li>
                <li>
                 
                  <button onClick={expedu} className="btn">
                    Experience & Education
                  </button>
                </li>
                <li>
              
                  <button onClick={portfolio} className="btn">
                    Portfolio
                  </button>
                </li>
                <li>
               
                  <button onClick={skills} className="btn">
                    Skills
                  </button>
                </li>
                <li>
                 
                  <button onClick={contact} className="btn">
                    Contact
                  </button>
                </li>
              </ul>
            </Offcanvas.Body>
            <button onClick={handleClose} className="close-menubtn">
                  <RiCloseFill/>
                  </button>
          </Offcanvas>
        </Container>
      </Navbar>
    </React.Fragment>
  );
}

export default NavbarMain;
